import { useEffect, useState } from "react";

const WARNING_AFTER_MS = 25 * 60 * 1000; // 25 minutes
const COUNTDOWN_SECONDS = 60;

// Fires `onExpire` once the fixed session window elapses. Session cleanup and
// redirect live in AuthContext.logout(), not here — this hook only decides when.
export function useSessionTimer(onExpire) {
  const [sessionWarning, setSessionWarning] = useState(false);
  const [sessionCountdown, setSessionCountdown] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    const warningTimeout = setTimeout(() => {
      setSessionWarning(true);
    }, WARNING_AFTER_MS);
    return () => clearTimeout(warningTimeout);
  }, []);

  useEffect(() => {
    if (!sessionWarning) return;
    setSessionCountdown(COUNTDOWN_SECONDS);
    const countdownInterval = setInterval(() => {
      setSessionCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          onExpire();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(countdownInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionWarning]);

  return { sessionWarning, sessionCountdown };
}
